<template>
  <div>
    <v-bottom-sheet
      v-model="visible"
    >
      <div class="bg-white br-top-2">
        <div class="d-flex align-center px-5 pb-2 pt-4">
          <v-btn
            fab
            x-small
            elevation="0"
            v-if="steps.active.number > 1"
            @click="setStep(steps.active.number - 1)"
            class="mr-5"
          >
            <Icon
              :width="20"
              :icon="'arrow-left'"
            />
          </v-btn>
          <div class="text--secondary">
            <b>{{ steps.active.title }}</b>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            fab
            x-small
            elevation="0"
            @click="hide()"
          >
            <Icon
              :width="20"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </v-btn>
        </div>
        <div>
          <v-stepper
            v-model="steps.active.number"
            elevation="0"
          >
            <v-stepper-items>
              <v-stepper-content step="1" class="pa-0 ma-0">
                <AvailableHours
                  :selectedDay="selectedDay"
                  ref="available-hours"
                  @select="select"
                  class="mx-5 mb-5"
                />
              </v-stepper-content>
              <v-stepper-content step="2" class="pa-0 ma-0">
                <SelectedHour
                  :selected="selected"
                  ref="selected-hour"
                />
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
require('@/plugins/OcularMoment')

@Component({
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    selectedDay: {
      required: false,
      default: null
    }
  },
  components: {
    AvailableHours: () => import(/* webpackPrefetch: true */ '@/views/calendar/resources/AvailableHours.vue'),
    SelectedHour: () => import(/* webpackPrefetch: true */ '@/views/calendar/resources/SelectedHour.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Sheet extends Vue {
  data () {
    return {
      visible: false,
      selected: null,
      steps: {
        list: [
          {
            number: 1,
            title: this.$t('calendar.select'),
            description: ''
          },
          {
            number: 2,
            title: this.$t('calendar.confirm'),
            description: ''
          }
        ],
        active: null
      }
    }
  }

  beforeMount () {
    this.steps.active = this.steps.list[0]
  }

  show () {
    this.setStep(1)
    this.visible = true
    setTimeout(async () => {
      this.$refs['available-hours'].getHours()
    }, 1)
  }

  hide () {
    this.visible = false
  }

  toggle () {
    this.visible = !this.visible
  }

  setStep (step) {
    const newStep = this.steps.list.find((stepItem) => stepItem.number === step)
    this.steps.active = newStep
  }

  select (selected) {
    this.selected = selected
    this.$store.state.calendar.schedule = this.$ocularMoment.timeZoneDate(this.selected.hour).format('DD/MM/YYYY')+" "+ this.$ocularMoment.timeZoneDate(this.selected.hour).format('h:mm a')
    this.setStep(2)

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: `El cliente seleccionó una hora de la fecha ${this.$ocularMoment.getDate(this.selectedDay, this.$store.state.locale).format('LL')}`,
      detail: `Hora seleccionada: ${this.selected.hour}`,
      actionType: 'SVAH',
      functionality: 4,
      functionalityData: {
        hour: this.selected.hour,
        event: this.selected.event
      },
      historyInteractionType: 'OSIFDV'
    })
  }
}
</script>

<style>
.br-top-2 {
  -webkit-border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-topright: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
